import branchManagementStopSchedulingComponent from './stop_scheduling.component';

let branchManagementStopSchedulingModule = angular.module('branchManagementStopScheduling', [])
  .component('branchManagementStopScheduling', branchManagementStopSchedulingComponent)
  .name;

export default branchManagementStopSchedulingModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/stop_scheduling/index.js